import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserDto } from 'src/app/models/UserDto';
import { filter } from 'rxjs/operators';
import { SharedService } from '../../../services/shared-service/shared.service';
import { Storage } from '@ionic/storage';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
	@Input() userDetails: any;
	@Output() logOutShow = new EventEmitter();
	public isShowHeader: boolean = false;
	currentRoute: string;
	public gamePageName: string = '';
	public gamePagesCount: number = 0;
	isOpen = false;

	constructor(public router: Router, private activatedRoute: ActivatedRoute, private sharedService: SharedService, private storageService: Storage) { }

	showLogoutPopover() {
		this.isOpen = !this.isOpen
		this.logOutShow.emit(this.isOpen);
	}

	hideLogoutPopover() {
		this.isOpen = false;
		this.logOutShow.emit(false);
	}

	async ngOnInit() {
		console.log(this.userDetails);

		this.sharedService._isLoggedIn$.subscribe(async (res: boolean) => {
			this.isShowHeader = res;

			if (res) {
				await this.setUserAndGamePageName();
			}
		});

		this.sharedService._setGamePageName$.subscribe(async (res: string) => {
			if (res !== undefined && res !== null && res !== '') {
				this.gamePageName = res;
			}
		});

		this.sharedService._setGamePagesCount$.subscribe(async (res: number) => {
			if (res !== undefined && res !== null && res !== 0) {
				this.gamePagesCount = res;
			}
		});

		await this.storageService.get('homeazzon_backoffice_Authenticated').then(async (res) => {
			if (res !== null) {
				this.isShowHeader = res;

				await this.setUserAndGamePageName();
			}
		}).catch((err) => {

		});

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(async (e:any) => {
			this.currentRoute = e.url;
			
			if (this.currentRoute.indexOf('/home') > -1 || this.currentRoute.indexOf('/auth') > -1) {
				this.isShowHeader = false;
			} else {
				this.isShowHeader = true;
			}
			await this.setUserAndGamePageName();
		});

		// Alternatively, you can also get the current route using ActivatedRoute snapshot:
		// this.currentRoute = this.activatedRoute.snapshot.url.join('/');
	}


	private async setUserAndGamePageName() {
		await this.storageService.get('homeazzon_backoffice_User').then((user) => {
			this.userDetails = user;

			var a = this.userDetails.PrivateLabelers;

			if (a !== undefined && a !== null && a.length > 0) {
				var b = a.filter(x => x.UserTypeId === 17);
				if (b !== undefined && b !== null && b.length > 0) {
					if (b.length > 1) {
						// propmt user to select a game page to manage
						this.gamePageName = b[0].Name;
					} else {
						this.gamePageName = b[0].Name;
					}
				}
			}
		}).catch((err) => {
		});
	}
}
